import getAutoReplyStatus from '../utils/getAutoReplyStatus';
import getCreateOofEventStatus from '../utils/getCreateOofEventStatus';
import getOofEventSubject from '../utils/getOofEventSubject';
import getExternalMessage from '../utils/getExternalMessage';
import getInternalMessage from '../utils/getInternalMessage';
import getDeclineMeetingMessage from '../utils/getDeclineMeetingMessage';
import getExternalAudience from '../utils/getExternalAudience';
import getDeclineNewReqestStatus from '../utils/getDeclineNewReqestStatus';
import getDeclineEventsForScheduled from '../utils/getDeclineEventsForScheduled';
import getDataForInitialState from '../utils/getDataForInitialState';
import getStartDateTime from '../utils/getStartDateTime';
import getEndDateTime from '../utils/getEndDateTime';
import getEventsToDelete from '../utils/getEventsToDelete';
import updateAutomaticRepliesInitialState from '../data/mutators/updateAutomaticRepliesInitialState';
import saveMailboxAutomaticRepliesConfiguration from '../services/saveMailboxAutomaticRepliesConfiguration';
import logDataOnSaveAutomaticReplies from '../utils/logDataOnSaveAutomaticReplies';
import OofState from 'owa-service/lib/contract/OofState';
import strings from 'owa-strings/owa-options-strings';
import { confirm } from 'owa-confirm-dialog';

/**
 * Method that saves the mailbox autoreply configuration also updates the initial state on success.
 */
export default async function saveAutomaticRepliesOption() {
    let autoReplyStatus = getAutoReplyStatus();
    let isDeclinedEventsChecked = getDeclineEventsForScheduled();
    let eventsToDelete = getEventsToDelete();

    let mailboxAutoReplyConfigurationOptions = null;
    if (autoReplyStatus == OofState.Disabled) {
        mailboxAutoReplyConfigurationOptions = {
            AutoReplyState: autoReplyStatus,
            ExternalAudience: getExternalAudience(),
        };
    } else {
        mailboxAutoReplyConfigurationOptions = {
            AutoReplyState: autoReplyStatus,
            CreateOOFEvent: getCreateOofEventStatus(),
            OOFEventSubject: getOofEventSubject(),
            ExternalMessage: getExternalMessage(),
            InternalMessage: getInternalMessage(),
            ExternalAudience: getExternalAudience(),
            AutoDeclineFutureRequestsWhenOOF: getDeclineNewReqestStatus(),
            DeclineEventsForScheduledOOF: isDeclinedEventsChecked,
            DeclineMeetingMessage: getDeclineMeetingMessage(),
            StartTime: getStartDateTime(),
            EndTime: getEndDateTime(),
            EventsToDeleteIDs: eventsToDelete,
        };
    }
    if (isDeclinedEventsChecked && eventsToDelete.length > 0) {
        confirm(
            '',
            strings.options_automaticReplies_emailReplies_cancel_meetings_dialogMessage,
            false,
            {
                hideCancelButton: true,
            }
        );
    }
    await saveMailboxAutomaticRepliesConfiguration(mailboxAutoReplyConfigurationOptions).then(
        () => {
            logDataOnSaveAutomaticReplies();
            updateAutomaticRepliesInitialState(getDataForInitialState());
        }
    );
}
